

































































































































































































import InvoicePartySheet from "@/components/invoice/InvoicePartySheet.vue";
import LineItemsForm from "@/components/repair-estimate/LineItemsForm.vue";
import MIconButton from "@/components/utility/mmmint/MIconButton.vue";
import MNoContent from "@/components/utility/mmmint/MNoContent.vue";
import MSelect from "@/components/utility/mmmint/MSelect.vue";
import MTextField from "@/components/utility/mmmint/MTextField.vue";
import SelectAssignees from "@/components/utility/SelectAssignees.vue";
import { ActivityTypeEnum } from "@/lib/enum/activity-type.enum";
import { RequestStatusEnum } from "@/lib/enum/request-status-enum";
import { TotalLossType } from "@/lib/enum/total-loss-type.enum";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { IAppraisal, Appraisal } from "@/models/appraisal.entity";
import CompanyMapDialog from "@/views/company/CompanyMapDialog.vue";
import { mixins } from "vue-class-component";
import { Component, Prop, Watch } from "vue-property-decorator";
import PartnerReportAppraisalUpdateDialog from "../partner/report/v2/repair/PartnerReportAppraisalUpdateDialog.vue";

@Component({
  components: {
    MIconButton,
    MNoContent,
    CompanyMapDialog,
    MTextField,
    MSelect,
    InvoicePartySheet,
    LineItemsForm,
    SelectAssignees,
    PartnerReportAppraisalUpdateDialog
  },
  filters: {}
})
export default class AppraisalSheet extends mixins(PermissionMixin) {
  @Prop({ required: true }) readonly appraisal!: IAppraisal;

  showDocument = false;
  showPositions = false;
  isUpdateDialog = false;

  openUpdateDialog() {
    if (this.canUpdateAppraisal) {
      this.isUpdateDialog = true;
    }
  }

  localAppraisal: IAppraisal = new Appraisal({});

  created() {
    this.localAppraisal = this.appraisal;
  }

  @Watch("appraisal", { immediate: true, deep: true })
  onAppraisalChanged(val: IAppraisal) {
    this.localAppraisal = val;
  }

  emitUpdateAppraisal() {
    this.$emit("update:appraisal", this.localAppraisal);
  }

  async onAssigneesUpdate(assignees: []) {
    await this.localAppraisal.updatePartial({ assignees });
  }

  async onAssigneesAdded(assignees: string[]) {
    if (!this.canUpdateAppraisal) return;
    await this.localAppraisal.createAssigneeActivity(ActivityTypeEnum.CREATE_ASSIGNEE, assignees);
  }

  async onAssigneesRemoved(assignees: string[]) {
    if (!this.canUpdateAppraisal) return;
    await this.localAppraisal.createAssigneeActivity(ActivityTypeEnum.DELETE_ASSIGNEE, assignees);
  }

  goToDetail() {
    if (!this.canUpdateAppraisal) return;
    this.localAppraisal.goTo(this.$router).detail();
  }

  get statusItems() {
    return Object.values(RequestStatusEnum).map(value => ({
      value,
      text: this.$t(`enums.RequestStatusEnum.${value}`)
    }));
  }

  get TotalLossTypeItems() {
    return Object.values(TotalLossType).map(value => ({
      value,
      text: this.$t(`enums.TotalLossType.${value}`)
    }));
  }
}
